import React from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';
type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: React.ReactNode;
}

const styles: Record<ButtonVariant, React.CSSProperties> = {
  primary: { background: 'var(--primary)', color: 'white', border: 'none' },
  secondary: { background: 'white', color: 'var(--text-secondary)', border: '1px solid var(--border)' },
  danger: { background: 'var(--error)', color: 'white', border: 'none' },
  ghost: { background: 'transparent', color: 'var(--text-secondary)', border: 'none' },
};

const sizes: Record<ButtonSize, React.CSSProperties> = {
  sm: { padding: '4px 10px', fontSize: '12px' },
  md: { padding: '8px 16px', fontSize: '13px' },
  lg: { padding: '10px 20px', fontSize: '14px' },
};

export const Button: React.FC<ButtonProps> = ({ variant = 'primary', size = 'md', children, style, ...props }) => (
  <button
    style={{
      borderRadius: 'var(--radius)',
      cursor: 'pointer',
      fontWeight: 600,
      transition: 'opacity 0.15s',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      ...styles[variant],
      ...sizes[size],
      ...style,
    }}
    {...props}
  >
    {children}
  </button>
);
